import * as tslib_1 from "tslib";
import React from 'react';
import { DuperbrowseStreamContext, } from './DuperbrowseStreamContext';
export var DuperbrowseStreamContextProvider = function (_a) {
    var children = _a.children, contextProps = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(DuperbrowseStreamContext.Provider, { value: contextProps }, children));
};
DuperbrowseStreamContextProvider.displayName =
    'DuperbrowseStreamContextProvider';
export default DuperbrowseStreamContextProvider;
//# sourceMappingURL=DuperbrowseStreamContextProvider.js.map